import React from "react";

import _ from 'lodash';
import cx from 'classnames';

import Content from "../../core/content";

import { BackgroundView } from '../../background';
import { getBoxShadow } from "../../../../services/cssHelper.service";

import styles from './card.module.scss';

const ContentCardWidget = React.memo(function ContentCardWidget({ className, style, widgetProps, breakpoint, children }) {
  const contentContext = React.useContext(Content.Context);
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const background = _.get(widgetProps, `properties.desktop.background`);
  const hoverStyle = _.get(widgetProps, `properties.desktop.hoverStyle`) || 'move_up_with_shadow';

  const content = _.get(widgetProps, 'template.content');

  const widgetStyles = {
    ...style,
    ...getStyles(widgetProps, breakpoint)
  }

  const handleItemClick = () => {
    contentContext.viewContent(widgetProps.parent, content);
  }

  return (
    <div
      id={id}
      className={cx(className, styles.contentCard, hoverStyle, "widget")}
      data-widget-id={id}
      data-widget-type={type}
      style={widgetStyles}
      onClick={handleItemClick}
    >
      <BackgroundView background={background} breakpoint={breakpoint} />
      {children}
    </div>
  )
});

/**
 * Generate Styles
 *
*/
export function getStyles(widget, breakpoint) {
  if (!widget) {
    return null;
  }

  const border = _.get(widget, `properties.${breakpoint}.border`);

  var styles = {};
  const topLeft = _.get(border, 'radius.topLeft', null);
  const topRight = _.get(border, 'radius.topRight', null);
  const bottomLeft = _.get(border, 'radius.bottomLeft', null);
  const bottomRight = _.get(border, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  const colorRgb = _.get(border, 'color');

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(border, 'width', 0);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  //DropShadow
  const shadow = _.get(widget, `properties.${breakpoint}.shadow`, {});
  const shadowStyle = getBoxShadow(shadow);
  styles = {
    ...styles,
    ...shadowStyle
  }

  return styles;
}

export { ContentCardWidget };
